"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var makeRequest = function makeRequest(url, apiKey) {
  var options = {
    headers: {
      'x-api-key': apiKey,
      'Content-Type': 'application/json'
    }
  };
  return _axios.default.get(url, options).then(function (response) {
    return response.data;
  }).catch(function (error) {
    return error;
  });
};

var wholesaleCustomersNear = function wholesaleCustomersNear(city, brand, limit, offset) {
  var url = '';
  var apiKey = '';

  if (window.location.hostname.includes('crescocannabis')) {
    url = 'https://api.crescolabs.com/p/customers?';
    apiKey = '73jjmpnQVc8JNX0JRMYH85DFkGQVxIXNf1Gfm6Bj';
  } else {
    url = 'https://x3wqo3qyra.execute-api.us-west-2.amazonaws.com/stage/p/customers?';
    apiKey = 'jQVtd4jQyQ3mQNkblMWRQ9SFjJJDM3Xc6QDGTZEC';
  }

  var params = "near=".concat(city, "&brands=").concat(brand, "&limit=").concat(limit, "&offset=").concat(offset);
  var request = url + params;
  return makeRequest(request, apiKey);
};

var _default = wholesaleCustomersNear;
exports.default = _default;